import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Utils } from '../common/Utils';
import {Observable} from 'rxjs';
import { ILookup } from '../common/models';

@Injectable()
export class ListService {

    constructor(private http: HttpClient) {
    }

    public getFields(webUrl: string, list: string): Observable<any> {
        const url =  Utils.removeSlash(webUrl) + '/_api/web/Lists/getbyTitle(\'' + Utils.escapeListName(list)
                    + '\')/Fields?$select=title,internalname,typeasstring,id&$filter=hidden eq false' +
                    ' and internalname ne \'LinkTitle\' and internalname ne \'LinkTitleNoMenu\'';
        return this.http.get(url, {
            headers: new HttpHeaders().set('Accept', 'application/json;odata=verbose'),
          });
    }

    public getViews(webUrl: string, list: string): Observable<any> {
        const url =  Utils.removeSlash(webUrl) + '/_api/web/Lists/getbyTitle(\'' + Utils.escapeListName(list)
                    + '\')/Views?$select=Title,ViewQuery';
        return this.http.get(url, {
            headers: new HttpHeaders().set('Accept', 'application/json;odata=verbose'),
          });
    }

    public getUserValues(webUrl: string) {
        const url =  Utils.removeSlash(webUrl) + '/_api/web/siteusers?$select=Id,Title,LoginName,Email';
        return this.http.get(url, {
            headers: new HttpHeaders().set('Accept', 'application/json;odata=verbose'),
        });
    }

    public getLookupValues(webUrl: string, listname: string, fieldname: string) {
        return new Observable<any>((obsr) => {
            let url =  Utils.removeSlash(webUrl) +
                    `/_api/web/lists/getbytitle('${listname}')/Fields?$filter=InternalName eq '${fieldname}'`;
            this.http.get(url, {
                headers: new HttpHeaders().set('Accept', 'application/json;odata=verbose'),
            }).subscribe((data: any) => {
                const lookupField = data.d.results[0].LookupField;
                url = Utils.removeSlash(webUrl) +
                `/_api/web/lists/getbytitle('${listname}')/Items?$select=${fieldname}/Id, ${fieldname}/${lookupField}&$expand=${fieldname}`;
                this.http.get(url, {
                    headers: new HttpHeaders().set('Accept', 'application/json;odata=verbose'),
                }).subscribe((data2: any) => {
                    obsr.next(data2.d.results.map(x => x[fieldname]));
                    obsr.complete();
                });
            });
        });
    }
}
